<template>
  <div class="vue-dropdown default-theme" ref="select_box">
    <div class="cur-name" :class="{'cur-name-active': isShow}" v-popover:popoverSelect>
      <div class="cur-name-text">
        <span :class="{'one-ellipsis': config.value.length}">{{selectValue}}</span>
        <span class="one-ellipsis ml05" v-show="config.value.length > 1">+ {{config.value.length - 1}}</span>
      </div>
      <i class="el-icon-arrow-up arrow" :class="{isReverse: isShow, isValue: config.value.length && !config.noCleara}" />
      <i v-if="config.value.length && !config.noCleara" class="el-icon-error close" @click.stop="removeAll"/>
    </div>
    <!-- 下拉弹框 -->
    <el-popover v-model="isShow"
      ref="popoverSelect"
      popper-class="select-popover"
      placement="bottom-start"
      trigger="click">
        <div class="select-popover-main">
          <div class="search-module clearfix" v-if="config.options.length">
            <el-input placeholder="搜索内容" v-model="searchText" />
          </div>
          <div class="list-box">
            <el-checkbox v-if="config.options.length && allShow" v-model="checkAll" @change="handleCheckedAll">全选</el-checkbox>
            <el-tree
              class="filter-tree"
              node-key="id"
              show-checkbox
              check-on-click-node
              :expand-on-click-node="false"
              :data="itemlist"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @check-change="handleCheckedChange"
              ref="tree">
            </el-tree>
          </div>
          <div class="select-footer">
            <el-button style="height:auto" size="mini" type="text" @click="handleClickClose">取消</el-button>
            <el-button style="height:auto" type="primary" size="mini" @click="handleClickSaveTemplateBtn">确定</el-button>
          </div>
        </div>
        <div class="select-popover-shodow" @click="isShow = false"></div>
    </el-popover>
  </div>
</template>

<script>
// import { deepCopy } from '@/utils/deep-copy'
export default {
  name: 'MultipleTreeSelect',
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      selectValue: '',
      isShow: false, // 下拉框是否显示
      isCancelClose: false, // 是否手动取消关闭
      searchText: '', // 搜索词
      itemlist: [], // 搜索过的下拉选项
      checkAll: false, // 是否全选
      allShow: true // 全选按钮是否展示
    }
  },
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.init()
      } else {
        !this.isCancelClose && this.handleClickSaveTemplateBtn()
      }
    },
    searchText(newVal, oldVal) { // 搜索框实时检索
      this.$refs.tree.filter(newVal.trim())
      this.cheackedAllEcho()
    },
    config: { // 选项列表变化时
      handler: function(newVal, oldVal) {
        this.initValue()
      },
      deep: true,
      immediate: true
    }
    // 'config.childrenKeys'(newVal) {
    //   this.config.value = this.config.value.filter(value => {
    //     const findIndex = newVal.findIndex(item => item === value)
    //     return findIndex > -1
    //   })
    // }
  },
  methods: {
    init() { // 初始化数据
      if (this.$refs.tree) {
        this.searchText = ''
        this.isCancelClose = false
        this.$refs.tree.setCheckedKeys(this.config.value)
        this.itemlist = this.config.options
        this.cheackedAllEcho()
      }
    },
    initValue() { // 初始选中值回显
      if (this.config.value.length > 0) {
        this.selectValue = this.getLabel(this.config.options, this.config.value[0])
        return
      }
      this.selectValue = this.config.placeholder || '请选择'
    },
    getLabel(list, id) {
      for (let i = 0; i < list.length; i++) {
        if (this.config.notOnlyChild) {
          if (list[i].id === id) {
            return list[i].name
          }
        }
        if (list[i].children) {
          const name = this.getLabel(list[i].children, id)
          if (name) {
            return name
          }
        } else {
          if (list[i].id === id) {
            return list[i].name
          }
        }
      }
      return ''
    },
    handleClickClose() {
      this.isCancelClose = true
      this.isShow = false
    },
    handleClickSaveTemplateBtn() {
      if (JSON.stringify(this.config.value) !== JSON.stringify(this.$refs.tree.getCheckedKeys(!this.config.notOnlyChild))) {
        this.config.value = this.$refs.tree.getCheckedKeys(!this.config.notOnlyChild)
        this.$emit('change', this.config)
      }
      this.handleClickClose()
    },
    removeAll() { // 删除全部
      this.config.value = []
      this.$emit('change', this.config)
      this.checkAll = false
      this.handleClickClose()
    },
    handleCheckedChange() {
      this.cheackedAllEcho()
    },
    handleCheckedAll(val) { // 全选
      this.config.childrenKeys.forEach(key => {
        const node = this.$refs.tree.getNode(key)
        if (val && node.visible && !node.checked) {
          this.$refs.tree.setChecked(key, val)
        } else if (!val && node.visible && node.checked) {
          this.$refs.tree.setChecked(key, val)
        }
      })
    },
    cheackedAllEcho() { // 全选态回显
      this.$nextTick(() => {
        let allShow = false
        let checkAll = true
        const childrenKeys = this.config.childrenKeys
        for (let i = 0; i < childrenKeys.length; i++) {
          const node = this.$refs.tree.getNode(childrenKeys[i])
          if (node.visible) {
            allShow = true
            if (!node.checked) {
              checkAll = false
            }
          }
        }
        this.allShow = allShow
        this.checkAll = checkAll
      })
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }
  }
}
</script>

<style lang="scss" scoped>
.vue-dropdown.default-theme {
  min-width: 120px;
  height: 32px;
  // display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
  &._self-show {
    display: block !important;
  }
}
.cur-name {
  display: flex;
  align-items: center;
  height: 100%;
  border: 1px solid $G4;
  border-radius: 2px;
  color: #555;
  cursor: pointer;
  font-size: 12px;
  padding: 10px;
  overflow: hidden;
  .cur-name-text{
    flex: 1;
    color: $G7;
    .one-ellipsis{
      line-height: 16px;
      padding: 0 4px;
      border-radius: 2px;
      background-color: $G3;
      color: $main-text-color;
    }
    .ml05{
      margin-left: 5px;
    }
  }
  .arrow{
    padding: 1px;
    margin-left: 5px;
    color:#C0C4CC;
    font-size: 14px;
    transition: transform .3s;
    transform: rotate(180deg);
  }
  .isReverse{
    font-size: 14px;
    color:#C0C4CC;
    transform: rotate(0deg);
  }
  .close{
    font-size: 14px;
    color: #C1C0CC;
    margin-left: 5px;
    display: none;
    &:hover{
      color: #9D9C9E;
    }
  }
  &:hover{
    border-color: #C0C4CC;
    .isValue{
      display: none;
    }
    .close{
      display: block;
    }
  }
}
.cur-name-active{
  border: 1px solid $main-color;
}
.search-module{
  padding: 4px 8px;
  ::v-deep .el-input__inner{
    border-top: none;
    border-left: none;
    border-right: none;
    padding-left: 0;
    padding-right: 0;
    border-radius: 0;
  }
}
.list-box{
  max-height: 300px;
  overflow-y: auto;
}
.tip-nodata {
  padding: 20px 0 10px;
  text-align: center;
  font-size: 13px;
  color: #bbbbbb;
}
::v-deep .el-checkbox{
  margin: 0;
  padding: 0 10px;
  line-height: 36px;
  display: block;
  &:hover{
    background-color: #f7f8fa;
  }
}
.select-footer{
  margin-top: 10px;
  padding: 5px 8px;
  box-shadow: 0 -2px 4px 0 rgb(0 0 0 / 3%);
  display: flex;
  justify-content: flex-end;
}
.el-popover.el-popper .el-button--primary{
  font-size: 12px;
}
.el-popover.el-popper .el-button--mini.el-button--text{
  font-size: 12px;
  border: 1px solid #DCDFE6;
  &:hover{
    border-color: $main-color;
  }
}
::v-deep .el-tree-node__content{
  padding-right: 20px;
  .el-tree-node__label{
    font-size: 13px;
  }
}
.select-popover-main{
  position: relative;
  z-index: 2;
  background: #ffffff;
}
.select-popover-shodow{
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100vw;
  height:100vh;
}
</style>
